import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {DEVELOPER_URL} from '../../index';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {useSelector} from 'react-redux';
import {BridgeDeviceTypeModel} from '../../../../types/bridge-device-type';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: BridgeDeviceTypeModel) => item.id;

export const BridgeDeviceTypeListScreen = memo(function BridgeDeviceTypeListScreen() {
    const {t} = useLocalization();
    const bridgeDeviceTypeList = useSelector(state => state.control.bridgeDeviceTypeList);

    const [selectedControl, setSelectedControl] = useState<BridgeDeviceTypeModel>(null);

    const displayNameExtractor = useCallback((item: BridgeDeviceTypeModel, column: ColumnModel) => {
        if (column.key === 'is_io') {
            return item.is_io_device ? 'IO' : 'Cam';
        }

        if (column.key === 'is_media') {
            return item.is_media_device ? t('yes') : t('no');
        }

        return item[column.key];
    }, [t]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 2,
            name: t('device_type_name'),
            key: 'name',
        },
        {
            length: 1,
            name: t('is_media'),
            key: 'is_media',
        },
        {
            length: 1,
            name: t('io/cam'),
            key: 'is_io',
        },
        {
            length: 1,
            name: t('entry_count'),
            key: 'input_count',
        },
        {
            length: 1,
            name: t('output_count'),
            key: 'output_count',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='developer' isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                className="camera-list-page"
                backUrl={DEVELOPER_URL}>
                <SettingsList
                    columns={columns}
                    listType='bridgeDeviceTypeList'
                    items={bridgeDeviceTypeList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedControl}
                    onItemSelected={setSelectedControl}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
